import {createAction} from "redux-actions";
import {USER_ACTION, USER_INFO} from "../constants/store";

export const user_set_action = createAction(USER_ACTION);
export const user_set_info = createAction(USER_INFO);